import { render } from "./ContaCertaConfigContainer.vue?vue&type=template&id=03f4a6cc"
import script from "./ContaCertaConfigContainer.vue?vue&type=script&lang=js"
export * from "./ContaCertaConfigContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__